import type { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";

import { v4 as uuidv4 } from "uuid";

import { markResultsNavigationNew } from "@/lib/results-navigation";
import { searchMetadataStore } from "@/lib/search-metadata-store";

import type { TextSearchQuery as TextSearchQueryInput } from "openapi/shop_agent/client";

/**
 * Curated query as returned in the backend GET /curated/home product rails.
 * The full search query is server-authoritative; the frontend only sends
 * the handle to the POST /curated endpoint.
 */
export interface CuratedQuery {
  handle: string;
  title: string;
  search_query: TextSearchQueryInput;
}

/**
 * Navigate to the full results page for a curated query.
 * Uses the server-returned search_query details to seed the local
 * search metadata store so the results page can render breadcrumbs, etc.
 */
export function navigateToCuratedSearch(router: AppRouterInstance, query: CuratedQuery): void {
  const threadId = uuidv4();
  const sq = query.search_query;

  searchMetadataStore.setSearchMetadata(threadId, sq.text, sq.facets ?? [], {
    rankingText: sq.ranking_text,
    rankingEmbeddingColumns: sq.ranking_embedding_columns as string[] | undefined,
    retrievalEmbeddingColumns: sq.retrieval_embedding_columns as string[] | undefined,
  });

  markResultsNavigationNew(threadId);
  router.push(`/results/${threadId}`);
}
